import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import PropTypes from 'prop-types';
import { Animated, StyleSheet, View } from 'react-native';
import { PagerRendererPropType } from './PropTypes';
var DefaultTransitionSpec = {
  timing: Animated.spring,
  tension: 68,
  friction: 12
};

var PagerExperimental =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PagerExperimental, _React$Component);

  function PagerExperimental() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PagerExperimental);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PagerExperimental)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_handleHandlerStateChange", function (event) {
      var GestureHandler = _this.props.GestureHandler;

      if (event.nativeEvent.state === GestureHandler.State.BEGAN) {
        _this.props.onSwipeStart && _this.props.onSwipeStart();
      } else if (event.nativeEvent.state === GestureHandler.State.END) {
        _this.props.onSwipeEnd && _this.props.onSwipeEnd();
        var _this$props = _this.props,
            navigationState = _this$props.navigationState,
            layout = _this$props.layout,
            _this$props$swipeDist = _this$props.swipeDistanceThreshold,
            swipeDistanceThreshold = _this$props$swipeDist === void 0 ? layout.width / 1.75 : _this$props$swipeDist,
            _this$props$swipeVelo = _this$props.swipeVelocityThreshold,
            swipeVelocityThreshold = _this$props$swipeVelo === void 0 ? 150 : _this$props$swipeVelo;
        var _event$nativeEvent = event.nativeEvent,
            translationX = _event$nativeEvent.translationX,
            translationY = _event$nativeEvent.translationY,
            velocityX = _event$nativeEvent.velocityX,
            velocityY = _event$nativeEvent.velocityY;
        var currentIndex = typeof _this._pendingIndex === 'number' ? _this._pendingIndex : navigationState.index;
        var nextIndex = currentIndex;

        if (Math.abs(translationX) > Math.abs(translationY) && Math.abs(velocityX) > Math.abs(velocityY) && (Math.abs(translationX) > swipeDistanceThreshold || Math.abs(velocityX) > swipeVelocityThreshold)) {
          nextIndex = Math.round(Math.min(Math.max(0, currentIndex - translationX / Math.abs(translationX)), navigationState.routes.length - 1));
        }

        if (!isFinite(nextIndex) || !_this.props.canJumpToTab(_this.props.navigationState.routes[nextIndex])) {
          nextIndex = currentIndex;
        }

        _this._transitionTo(nextIndex, velocityX);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_transitionTo", function (index, velocity) {
      var animated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var offset = -index * _this.props.layout.width;

      if (_this.props.animationEnabled === false || animated === false) {
        _this.props.panX.setValue(0);

        _this.props.offsetX.setValue(offset);

        return;
      }

      var timing = DefaultTransitionSpec.timing,
          transitionConfig = _objectWithoutProperties(DefaultTransitionSpec, ["timing"]);

      var useNativeDriver = _this.props.useNativeDriver;
      Animated.parallel([timing(_this.props.panX, _objectSpread({}, transitionConfig, {
        toValue: 0,
        velocity: velocity,
        useNativeDriver: useNativeDriver
      })), timing(_this.props.offsetX, _objectSpread({}, transitionConfig, {
        toValue: offset,
        velocity: velocity,
        useNativeDriver: useNativeDriver
      }))]).start(function (_ref) {
        var finished = _ref.finished;

        if (finished) {
          var route = _this.props.navigationState.routes[index];

          _this.props.jumpTo(route.key);

          _this.props.onAnimationEnd && _this.props.onAnimationEnd();
          _this._pendingIndex = null;
        }
      });
      _this._pendingIndex = index;
    });

    return _this;
  }

  _createClass(PagerExperimental, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.navigationState.routes.length !== this.props.navigationState.routes.length || prevProps.layout.width !== this.props.layout.width) {
        this._transitionTo(this.props.navigationState.index, undefined, false);
      } else if (prevProps.navigationState.index !== this.props.navigationState.index && this.props.navigationState.index !== this._pendingIndex) {
        this._transitionTo(this.props.navigationState.index);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          GestureHandler = _this$props2.GestureHandler,
          panX = _this$props2.panX,
          offsetX = _this$props2.offsetX,
          layout = _this$props2.layout,
          navigationState = _this$props2.navigationState,
          swipeEnabled = _this$props2.swipeEnabled,
          children = _this$props2.children;
      var width = layout.width;
      var routes = navigationState.routes;
      var maxTranslate = width * (routes.length - 1);
      var translateX = routes.length > 1 ? Animated.add(panX, offsetX).interpolate({
        inputRange: [-maxTranslate, 0],
        outputRange: [-maxTranslate, 0],
        extrapolate: 'clamp'
      }) : 0;
      return React.createElement(GestureHandler.PanGestureHandler, {
        enabled: layout.width !== 0 && swipeEnabled !== false,
        minDeltaX: 10,
        onGestureEvent: Animated.event([{
          nativeEvent: {
            translationX: this.props.panX
          }
        }], {
          useNativeDriver: this.props.useNativeDriver
        }),
        onHandlerStateChange: this._handleHandlerStateChange
      }, React.createElement(Animated.View, {
        style: [styles.sheet, width ? {
          width: routes.length * width,
          transform: [{
            translateX: translateX
          }]
        } : null]
      }, React.Children.map(children, function (child, i) {
        var route = navigationState.routes[i];
        var focused = i === navigationState.index;
        return React.createElement(View, {
          key: route.key,
          testID: _this2.props.getTestID({
            route: route
          }),
          accessibilityElementsHidden: !focused,
          importantForAccessibility: focused ? 'auto' : 'no-hide-descendants',
          style: width ? {
            width: width
          } : focused ? StyleSheet.absoluteFill : null
        }, focused || width ? child : null);
      })));
    }
  }]);

  return PagerExperimental;
}(React.Component);

_defineProperty(PagerExperimental, "propTypes", _objectSpread({}, PagerRendererPropType, {
  swipeDistanceThreshold: PropTypes.number,
  swipeVelocityThreshold: PropTypes.number,
  GestureHandler: PropTypes.object
}));

_defineProperty(PagerExperimental, "defaultProps", {
  canJumpToTab: function canJumpToTab() {
    return true;
  }
});

export { PagerExperimental as default };
var styles = StyleSheet.create({
  sheet: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'stretch'
  }
});